module.exports = __webpack_public_path__ + "img/bg-hero.1c6fd702.webp";